
import MediaCenter from './src/MediaCenter'
import MediaCenterMsg from './src/MediaCenterMsg'
import PreviewPlayer from './src/PreviewPlayer'
import PlaybackPlayer from './src/PlaybackPlayer'

const global = window || {};

const ZJPlayer = {
    MediaCenter,
    MediaCenterMsg,
    PreviewPlayer,
    PlaybackPlayer,
};

const install = function(Vue, opts) {
    global.ZJPlayer = ZJPlayer;
    MediaCenter.install(Vue, opts);
};

export default {
    install,
    ...ZJPlayer
};